<div class="container">
  <img src="assets/img/logo.svg" alt="Generali Italia" />
  <div class="home-title">
    <span><b>CLAIMS</b></span>
    <grid-divider variant="vertical"></grid-divider>
    <span style="align-self: end">platform</span>
  </div>
</div>
